export const USE_REDUX_LOG =
  process.env.REACT_APP_ENABLE_REDUX_LOG === `true` ? true : false;

export const REACT_APP_RESTFUL_BASE_URL_FOT_API =
  process.env.REACT_APP_RESTFUL_BASE_URL_FOT_API ?? "";

export const REACT_APP_RESTFUL_AUTH_URL_LOYALTY =
  process.env.REACT_APP_RESTFUL_AUTH_URL_LOYALTY ?? "";

export const RESTFUL_TRANS_URL = process.env.REACT_APP_RESTFUL_TRANS_URL || "";

//Firebase
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_TOKEN_NOTIFICATION;
export const FIREBASE_apiKey = process.env.REACT_APP_FIREBASE_apiKey;
export const FIREBASE_authDomain = process.env.REACT_APP_FIREBASE_authDomain;
export const FIREBASE_databaseURL = process.env.REACT_APP_FIREBASE_databaseURL;
export const FIREBASE_projectId = process.env.REACT_APP_FIREBASE_projectId;
export const FIREBASE_storageBucket =
  process.env.REACT_APP_FIREBASE_storageBucket;
export const FIREBASE_messagingSenderId =
  process.env.REACT_APP_FIREBASE_messagingSenderId;
export const REACT_APP_FIREBASE_appId = process.env.REACT_APP_FIREBASE_appId;
export const FIREBASE_measurementId =
  process.env.REACT_APP_FIREBASE_measurementId;

export const ENDPOINT_API_NOTICE =
  process.env.REACT_APP_ENDPOINT_API_NOTICE || "";
